"use strict";
// Copyright © 2021 Move Closer
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageBuilder = void 0;
const PageBuilder_1 = __importDefault(require("./PageBuilder"));
exports.PageBuilder = PageBuilder_1.default;
exports.default = PageBuilder_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9QYWdlQnVpbGRlci9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsK0JBQStCOzs7Ozs7QUFFL0IsZ0VBQXVDO0FBRTlCLHNCQUZGLHFCQUFXLENBRUU7QUFDcEIsa0JBQWUscUJBQVcsQ0FBQSIsInNvdXJjZXNDb250ZW50IjpbIi8vIENvcHlyaWdodCDCqSAyMDIxIE1vdmUgQ2xvc2VyXG5cbmltcG9ydCBQYWdlQnVpbGRlciBmcm9tICcuL1BhZ2VCdWlsZGVyJ1xuXG5leHBvcnQgeyBQYWdlQnVpbGRlciB9XG5leHBvcnQgZGVmYXVsdCBQYWdlQnVpbGRlclxuIl19